import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ breakpoints, custom, palette }: Theme) => ({
    input: {
      position: 'absolute',
      visibility: 'hidden',
    },
    fileUpload: {
      padding: 15,
      color: palette.primary.main,
      border: `2px solid ${palette.primary.main}`,
      fontWeight: 'bold',
      [breakpoints.down('xs')]: {
        maxWidth: 'initial',
      },
    },
    fileUploadContainer: {
      position: 'relative',
    },
    dropFileElement: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      padding: 10,
      marginTop: 4,
      borderRadius: 8,
      border: `dashed 1px ${custom.grey[10]}`,
    },
    uploadButtonLabel: {
      marginRight: 15,
      flexShrink: 0,
      width: '100%',
      maxWidth: 260,
      [breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
    uploadButtonContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    uploadButtonContainerError: {
      borderColor: custom.status.danger.contrastText,
    },
    fileName: {
      fontSize: 14,
      color: custom.grey[2],
      wordBreak: 'break-word',
      [breakpoints.down('xs')]: {
        paddingTop: 10,
      },
    },
    fileNameError: {
      color: custom.status.danger.contrastText,
    },
  })
);
